import { useDispatch } from 'react-redux';

import { Flex, FlexContainer } from '@demandstar/components/styles';
import { DSButton } from '@demandstar/components/button';

import { ModalPopUp, ModalPopUpProps } from '../../modals/ModalPopUp';
import { AddQuotesState } from '../../../../store/reducers/addquotes';
import { Assert } from '../../../../utils/helpers';
import { deleteDocConfirmMsgText } from '../../../../utils/texts';
import { submitAddBidDocumentDelete } from '../../../../store/actions';
import { submitAddQuotesDocumentDelete } from '../../../../store/actions';
import { useDSSelector } from '../../../../store/reducers';

interface DeleteDocumentProps {
  type: 'quote' | 'bid';
  closeModal: () => void;
  bidId?: number;
  bidDocId?: number;
  message?: string
}

export const DeleteDocument = (props: DeleteDocumentProps) => {
  const { closeModal, bidId = '', type, message } = props;

  const deleteBidDocumentDetails = useDSSelector(state => state.addbid.deleteDocumentDetails);
  const quoteId = useDSSelector(
    state => (state.addquotes as AddQuotesState).deleteDocumentDetails?.quotesId,
  );
  const quoteDocId = useDSSelector(
    state => (state.addquotes as AddQuotesState).deleteDocumentDetails?.quoteDocId,
  );

  const bidDocId = props.bidDocId || deleteBidDocumentDetails?.bidDocId || '';

  const dispatch = useDispatch();

  function deleteDocument() {
    if (type === 'quote') {
      Assert(!!quoteDocId, 'We expect to have quoteDocId');
      Assert(!!quoteId, 'We expect to have quoteId');
      dispatch(submitAddQuotesDocumentDelete({ quoteDocId, quoteId }));
    } else {
      Assert(!!bidDocId, 'We expect to have bidDocId');
      Assert(!!bidId, 'We expect to have bidId');
      dispatch(submitAddBidDocumentDelete({ bidId, bidDocId }));
    }
  }

  return (
    <div data-testid='add-bid.document-upload.delete.modal'>
      <p>{message ?? deleteDocConfirmMsgText}</p>
      <FlexContainer>
        <Flex grow={0}>
          <DSButton
            type='secondary'
            title='Cancel'
            onClick={closeModal}
            dataTestId='add-bid.document-upload.delete.modal.cancel-btn'
          >
            Cancel
          </DSButton>
        </Flex>
        <Flex></Flex>
        <Flex grow={0}>
          <DSButton
            type='submit'
            title='Delete'
            onClick={deleteDocument}
            dataTestId='add-bid.document-upload.delete.modal.delete-btn'
          >
            Delete
          </DSButton>
        </Flex>
      </FlexContainer>
    </div>
  );
};

type DeleteDocumentModalProps = Omit<ModalPopUpProps, 'size' | 'title'> & DeleteDocumentProps;

export const DeleteDocumentModal = (props: DeleteDocumentModalProps) => {
  const { closeModal, bidId, type, isOpen, message } = props;

  return (
    <ModalPopUp size='md' title='Confirmation' closeModal={closeModal} isOpen={isOpen}>
      <DeleteDocument closeModal={closeModal} bidId={bidId} type={type} message={message} />
    </ModalPopUp>
  );
};
